<template>
  <transition name="product">
    <div class="ClueEntry">
      <van-nav-bar
        @click-left="onClickLeft"
        :title="form.eciInfoVerifyGetInfoOutput.name"
        left-text="返回"
        left-arrow
      >
      </van-nav-bar>
      <div>
        <van-cell-group>
          <van-field
            readonly
            :value="form.eciInfoVerifyGetInfoOutput.contactInfo.phoneNumber"
            label="电话"
            placeholder="无"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            readonly
            :value="form.eciInfoVerifyGetInfoOutput.name"
            label="企业名称"
            placeholder="无"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            readonly
            :value="form.eciInfoVerifyGetInfoOutput.contactInfo.email"
            label="邮箱"
            placeholder="无"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            readonly
            :value="form.eciInfoVerifyGetInfoOutput.address"
            label="地址"
            placeholder="无"
          />
        </van-cell-group>
      </div>
      <div class="comWrapper card mt-2 p-3">
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          工商信息
        </div>
        <div class="d-flex justify-content-between mt-2">
          <div style="flex: 1">
            <div class="fontstyle">成立日期</div>
            <div class="fontstyleS">
              {{ form.eciInfoVerifyGetInfoOutput.startDate }}
            </div>
          </div>
          <div style="flex: 1">
            <div class="fontstyle">工商注册号</div>
            <div class="fontstyleS">
              {{ form.eciInfoVerifyGetInfoOutput.no }}
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <div style="flex: 1">
            <div class="fontstyle">注册资本</div>
            <div class="fontstyleS">
              {{ form.eciInfoVerifyGetInfoOutput.recCap }}
            </div>
          </div>
          <div style="flex: 1">
            <div class="fontstyle">实缴资本</div>
            <div class="fontstyleS">
              {{ form.eciInfoVerifyGetInfoOutput.registCapi }}
            </div>
          </div>
        </div>
        <div class="mt-2">
          <div class="fontstyle">统一社会信用代码</div>
          <div class="fontstyleS">
            {{ form.eciInfoVerifyGetInfoOutput.creditCode }}
          </div>
        </div>
        <div class="mt-2">
          <div class="fontstyle">注册地址</div>
          <div class="fontstyleS">
            {{ form.eciInfoVerifyGetInfoOutput.address }}
          </div>
        </div>
        <div class="mt-2">
          <div class="fontstyle">经营范围</div>
          <div class="fontstyleS">
            {{ form.eciInfoVerifyGetInfoOutput.scope }}
          </div>
        </div>
      </div>
      <div class="comWrapper card mt-2 mb-2 p-3">
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span style="background: #f44336"></span>
          发现异常
        </div>
        <van-cell-group>
          <van-cell
            title="失信记录"
            @click="viewRiskDetail('shiXinCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.sxCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.sxCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="被执行信息"
            @click="viewRiskDetail('zhiXingCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.zxCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.zxCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="开庭公告信息"
            @click="viewRiskDetail('courtAnnoCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.csaCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.csaCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="裁判文书信息"
            @click="viewRiskDetail('judgmentDocCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.judgementTotalCount > 0
                ? '发现' +
                  form.riskScanGetComRiskInfoOutput.judgementTotalCount +
                  '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="司法拍卖"
            @click="viewRiskDetail('judicialSaleCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.jsCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.jsCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="法人变更"
            @click="viewRiskDetail('opChangePromptCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.operlist > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.operlist + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="大股东变更"
            @click="viewRiskDetail('parChangePromptCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.partnerList > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.partnerList + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="股权出质"
            @click="viewRiskDetail('equityPledgedCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.pledgeCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.pledgeCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="动产抵押"
            @click="viewRiskDetail('chattelMortgageCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.mPledgeCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.mPledgeCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="股权冻结"
            @click="viewRiskDetail('equityFreezeCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.assistanceCount > 0
                ? '发现' +
                  form.riskScanGetComRiskInfoOutput.assistanceCount +
                  '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="行政处罚"
            @click="viewRiskDetail('adminPenaltyCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.apList > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.apList + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="土地抵押"
            @click="viewRiskDetail('landMortgageCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.lmCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.lmCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="环保处罚"
            @click="viewRiskDetail('envPunishmentCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.enpTotalCount > 0
                ? '发现' +
                  form.riskScanGetComRiskInfoOutput.enpTotalCount +
                  '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
          <van-cell
            title="税收违法"
            @click="viewRiskDetail('taxIllegalCheck')"
            :value="
              form.riskScanGetComRiskInfoOutput.tiCount > 0
                ? '发现' + form.riskScanGetComRiskInfoOutput.tiCount + '条'
                : '暂无'
            "
            icon="browsing-history-o"
          />
        </van-cell-group>
      </div>
    </div>
  </transition>
</template>
<script>
import meheader from "@/components/meheader";

export default {
  name: "Scan",
  components: {
    meheader,
  },
  data() {
    return {
      companyId: 0,
      companyName: "",
      allRiskInfo: {
        adminPenaltyCheck: { paging: {}, data: [] },
        chattelMortgageCheck: { paging: {}, data: [] },
        courtAnnoCheck: { paging: {}, data: [] },
        envPunishmentCheck: { paging: {}, data: [] },
        equityFreezeCheck: { paging: {}, data: [] },
        equityPledgedCheck: { paging: {}, data: [] },
        judgmentDocCheck: { paging: {}, data: [] },
        judicialSaleCheck: { paging: {}, data: [] },
        landMortgageCheck: { paging: {}, data: [] },
        opChangePromptCheck: { paging: {}, data: [] },
        parChangePromptCheck: { paging: {}, data: [] },
        shiXinCheck: { paging: {}, data: [] },
        taxIllegalCheck: { paging: {}, data: [] },
        zhiXingCheck: { paging: {}, data: [] },
      },
      form: {
        companyId: "",
        eciInfoVerifyGetInfoOutput: {
          name: "",
          contactInfo: {
            phoneNumber: "",
            email: "",
          },
          address: "",
          startDate: "",
          no: "",
          recCap: "",
          registCapi: "",
          creditCode: "",
          scope: "",
        },
        riskScanGetComRiskInfoOutput: {
          sxCount: 0,
          zxCount: 0,
          csaCount: 0,
          judgementTotalCount: 0,
          jsCount: 0,
          operlist: 0,
          partnerList: 0,
          pledgeCount: 0,
          mPledgeCount: 0,
          assistanceCount: 0,
          apList: 0,
          lmCount: 0,
          enpTotalCount: 0,
          tiCount: 0,
        },
      },
    };
  },
  methods: {
    viewRiskDetail(key) {
      const count = this.rlen(key);
      if (void 0 == count || count == 0) return;
      this.dakaizhezhao1(this.allRiskInfo[key].data, key);
    },
    dakaizhezhao1(data, key) {
      data.forEach((item, index) => {
        item.sort = index + 1;
      });

      window.localStorage.setItem("risk_data", JSON.stringify(data));

      this.$router.push({
        name: "ScanDetail",
        query: {
          key,
          companyId: this.form.companyId,
        },
      });
    },
    onClickLeft() {
      this.$router.back();
    },
    getallRiskInfo() {
      this.request({
        url: "/v1.0/company/getCompanyBaseAndRiskInfo",
        method: "GET",
        params: { searchkey: this.companyName },
      })
        .then((res) => {
          console.log(res, "yjc");
          if (res.success) {
            console.log(res.data.allRiskInfo.courtAnnoCheck.paging.totalRecords, "第二个接口");
            let obj=res.data
            this.allRiskInfo =  obj.allRiskInfo;
            this.form.riskScanGetComRiskInfoOutput = {
              // sxCount: obj.allRiskInfo.shiXinCheck.paging.totalRecords,
              sxCount: obj.allRiskInfo.shiXinCheck.paging!==null?obj.allRiskInfo.shiXinCheck.paging.totalRecords:'',
              zxCount: obj.allRiskInfo.courtAnnoCheck.paging!==null?obj.allRiskInfo.courtAnnoCheck.paging.totalRecords:'',
              judgementTotalCount: obj.allRiskInfo.judgmentDocCheck.paging!==null?obj.allRiskInfo.judgmentDocCheck.paging.totalRecords:'',
              jsCount: obj.allRiskInfo.judicialSaleCheck.paging!==null?obj.allRiskInfo.judicialSaleCheck.paging.totalRecords:'',
              operlist: obj.allRiskInfo.opChangePromptCheck.paging!==null?obj.allRiskInfo.opChangePromptCheck.paging.totalRecords:'',
              partnerList: obj.allRiskInfo.parChangePromptCheck.paging!==null?obj.allRiskInfo.parChangePromptCheck.paging.totalRecords:'',
              pledgeCount: obj.allRiskInfo.equityPledgedCheck.paging!==null?obj.allRiskInfo.equityPledgedCheck.paging.totalRecords:'',
              mPledgeCount: obj.allRiskInfo.chattelMortgageCheck.paging!==null?obj.allRiskInfo.chattelMortgageCheck.paging.totalRecords:'',
              assistanceCount: obj.allRiskInfo.equityFreezeCheck.paging!==null?obj.allRiskInfo.equityFreezeCheck.paging.totalRecords:'',
              apList: obj.allRiskInfo.adminPenaltyCheck.paging!==null?obj.allRiskInfo.adminPenaltyCheck.paging.totalRecords:'',
              lmCount: obj.allRiskInfo.landMortgageCheck.paging!==null?obj.allRiskInfo.landMortgageCheck.paging.totalRecords:'',
              enpTotalCount: obj.allRiskInfo.envPunishmentCheck.paging!==null?obj.allRiskInfo.envPunishmentCheck.paging.totalRecords:'',
               tiCount: obj.allRiskInfo.taxIllegalCheck.paging!==null?obj.allRiskInfo.taxIllegalCheck.paging.totalRecords:'',
              // zxCount: obj.allRiskInfo.zhiXingCheck.paging.totalRecords,
              // csaCount: obj.allRiskInfo.courtAnnoCheck.paging.totalRecords,
              // judgementTotalCount: obj.allRiskInfo.judgmentDocCheck.paging.totalRecords,
              // jsCount: obj.allRiskInfo.judicialSaleCheck.paging.totalRecords,
              // operlist: obj.allRiskInfo.opChangePromptCheck.paging.totalRecords,
              // partnerList: obj.allRiskInfo.parChangePromptCheck.paging.totalRecords,
              // pledgeCount:obj.allRiskInfo.equityPledgedCheck.paging.totalRecords,
              // mPledgeCount: obj.allRiskInfo.chattelMortgageCheck.paging.totalRecords,
              // assistanceCount: obj.allRiskInfo.equityFreezeCheck.paging.totalRecords,
              // apList: obj.allRiskInfo.adminPenaltyCheck.paging.totalRecords,
              // lmCount: obj.allRiskInfo.landMortgageCheck.paging.totalRecords,
              // enpTotalCount:obj.allRiskInfo.envPunishmentCheck.paging.totalRecords,
              // tiCount: obj.allRiskInfo.taxIllegalCheck.paging.totalRecords,
            };
            console.log(this.form.riskScanGetComRiskInfoOutput.csaCount,'开停公告')
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.clear();
        });
    },
  },
  computed: {
    rlen() {
      return (key) => {
        try {
          return this.allRiskInfo[key].paging.totalRecords;
        } catch (e) {
          return this.allRiskInfo[key].data.length;
        }
      };
    },
  },
  created() {
    this.companyId = this.$route.query.companyId;
    this.companyName = this.$route.query.companyName;
    let obj = localStorage.getItem("businessCard_data");
    console.log(JSON.parse(obj), 888);
    let Ydata = JSON.parse(obj);
    this.getallRiskInfo();
    try {
      obj = JSON.parse(obj);
      Object.assign(this.form.eciInfoVerifyGetInfoOutput, Ydata);
      this.form.companyId = this.companyId;
      // this.allRiskInfo = obj.allRiskInfo;
      // console.log(obj.allRiskInfo);
      // this.form.riskScanGetComRiskInfoOutput = {
      //   sxCount: obj.allRiskInfo.shiXinCheck.data.length,
      //   zxCount: obj.allRiskInfo.zhiXingCheck.paging.totalRecords,
      //   csaCount: obj.allRiskInfo.courtAnnoCheck.paging.totalRecords,
      //   judgementTotalCount: obj.allRiskInfo.judgmentDocCheck.data.length,
      //   jsCount: obj.allRiskInfo.judicialSaleCheck.data.length,
      //   operlist: obj.allRiskInfo.opChangePromptCheck.data.length,
      //   partnerList: obj.allRiskInfo.parChangePromptCheck.data.length,
      //   pledgeCount: obj.allRiskInfo.equityPledgedCheck.paging.totalRecords,
      //   mPledgeCount: obj.allRiskInfo.chattelMortgageCheck.data.length,
      //   assistanceCount: obj.allRiskInfo.equityFreezeCheck.paging.totalRecords,
      //   apList: obj.allRiskInfo.adminPenaltyCheck.paging.totalRecords,
      //   lmCount: obj.allRiskInfo.landMortgageCheck.data.length,
      //   enpTotalCount: obj.allRiskInfo.envPunishmentCheck.paging.totalRecords,
      //   tiCount: obj.allRiskInfo.taxIllegalCheck.data.length,
      // };
      // console.log("businessCard_data", obj);
      // console.log(this.form,456)
    } catch (e) {}
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.fontstyle {
  font-size: 14px;
  color: #646566;
}
.fontstyleS {
  font-size: 14px;
}
.ClueEntry {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
.comWrapper {
  width: 100%;
  padding: 10px;
  .comWrapper-wrapper {
    span {
      display: inline-block;
      width: 8px;
      height: 12px;
      background: #1989fa;
    }
  }
}
</style>
